/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Close_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Close position modal" |
*
* @param {Position_Modal_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_close_aria_label = /** @type {((inputs?: Position_Modal_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la boite de dialogue de position")
	if (locale === "de") return /** @type {LocalizedString} */ ("Modal für geschlossene Position")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi posizione modale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Модель закрытого положения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar posición modal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭位置模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置モーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बंद स्थिति मॉडल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("modal de posição fechada")
	return /** @type {LocalizedString} */ ("Close position modal")
});